import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SERVER_API_URL } from 'src/app/app.constants';
import { createRequestOption } from 'src/app/shared/util/request-util';
import { ILossPayee as any, LossPayee } from 'src/app/shared/model/loss-payee.model';

type EntityResponseType = HttpResponse<any>;
type EntityArrayResponseType = HttpResponse<any[]>;

@Injectable({
  providedIn: 'root'
})
export class EsgReportService {

  private resourceUrl = SERVER_API_URL + 'api/';

  constructor(private http: HttpClient) { }


  get(url?: string, req?: any): Observable<EntityResponseType> {
    const options = createRequestOption(req);
    return this.http.get<any>(this.resourceUrl + url, { params: options, observe: 'response' });
  }

  postByUrl(data: any, url: string): Observable<EntityResponseType> {
    return this.http.post<any>(this.resourceUrl + url, data, { observe: 'response' });
  }

  postByUrlWithBlob(data: any, url: string): Observable<HttpResponse<Blob>> {
    return this.http.post(this.resourceUrl + url, data, { observe: 'response', responseType: 'blob' });
  }
  
}
